import React, { useEffect, useState } from "react";
import "../../3Inbox/InvoiceView/InvoiceView.css";
import ArchiveInvoiceForm from "../ArchiveInvoiceForm/ArchiveInvoiceForm";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedInvoiceData } from "../../../../Reducer/SelectedInvoiceDataReducer";
import Loader from "../../../../Components/Loader/Loader";
import { InvoiceDocumentViewer } from "../../../../Components/DocumentViewer/InvoiceDocumentViewer";
import {
  DeleteInvoice,
  GetInvoiceService,
  GetInvoicesService_NEW,
} from "../../../../Services/InvoiceService/InvoiceService";
import CancelBtn from "../../../../Components/CustomButtons/CancelBtn/CancelBtn";
import ConfirmPopup from "../../../../Components/ConfirmPopup/ConfirmPopup";
import AlertMessage from "../../../../Components/AlertMessage/AlertMessage";
import { Tooltip } from "../../../../Components/CommonUI/tooltip";
import { InvoiceType } from "../../../../Types/Invoice";
import { MdDelete } from "react-icons/md";
import { setSelectedInvoice } from "../../../../Reducer/SelectedInvoiceReducer";
import InvoiceForm from "../../3Inbox/InvoiceForm/InvoiceForm";
interface InvoiceViewProps {
  setInvoiceView: React.Dispatch<React.SetStateAction<boolean>>;
  refreshInvoices?: any;
  sortSettings?: any;
  fullinvoices?: any[];
  totalInvoiceCount?: number;
}

const ArchiveInvoiceView: React.FC<InvoiceViewProps> = ({
  setInvoiceView,
  refreshInvoices,
  sortSettings,
  fullinvoices,
  totalInvoiceCount,
}) => {
  const dispatch = useDispatch();
  const [openPopup, setOpenPopup] = useState(false);
  const [invoiceDataSource, setInvoiceDataSource] = useState<InvoiceType[]>([]);
  const [loaderStatus, setLoaderStatus] = useState(false);
  const [allInvoices, setAllInvoices] = useState<any[]>([]);
  const [currentInvoiceIndex, setCurrentInvoiceIndex] = useState(0);

  // Fetch selected invoice from Redux store
  const selectedInvoice = useSelector((state: any) => state.selectedInvoice);
  const selectedClient = useSelector((state: any) => state.selectedClient);
  const [hover, setHover] = useState(false);
  const savedSort = localStorage.getItem("sortSettings");
  // const FetchAllInvoices = async () => {
  //   try {
  //     // Get userId from selected client
  //     const userId = selectedClient?.selectedClient?.userId;
  //     const stageId = selectedInvoice?.selectedInvoice?.stageId || 2;

  //     if (!userId) {
  //       console.error("No userId found in selectedClient");
  //       return;
  //     }

  //     // Call GetInvoicesService with full parameters - first call to get total count
  //     const result = await GetInvoicesService_NEW({
  //       userId,
  //       stageIds: [],
  //       after: null,
  //       // order: null,
  //       // reversed: false,
  //       archiveStatuses:["Archived", "AlreadyExported"],
  //     });

  //     if (result && result.TotalItem) {
  //       // Use the total count as the limit for fetching all invoices
  //       const totalCount = result.TotalItem;

  //       // Fetch all invoices using the total count as limit
  //       const allInvoicesResult = await GetInvoicesService_NEW({
  //         userId,
  //         stageIds: [],
  //         after: null,
  //         archiveStatuses: ["Archived", "AlreadyExported"],
  //         limit: result.TotalItem, // Fetch all invoices in one go for easier navigation in
  //         order: sortSettings.key || "default",
  //         reversed: sortSettings.direction || false,
  //       });

  //       if (
  //         allInvoicesResult &&
  //         allInvoicesResult.Items &&
  //         Array.isArray(allInvoicesResult.Items)
  //       ) {
  //         setAllInvoices(allInvoicesResult.Items);

  //         // Find and set the current invoice index
  //         const currentId = selectedInvoice?.selectedInvoice?.id;
  //         const currentIndex = allInvoicesResult.Items.findIndex(
  //           (inv: any) => inv.id === currentId,
  //         );
  //         if (currentIndex !== -1) {
  //           setCurrentInvoiceIndex(currentIndex);
  //           // Fetch full invoice details for the current invoice
  //           const fullInvoice = await GetInvoiceService(currentId);
  //           if (fullInvoice) {
  //             setInvoiceDataSource([fullInvoice]);
  //             dispatch(setSelectedInvoiceData(fullInvoice));
  //           }
  //         }
  //       } else {
  //         console.warn("No invoices found");
  //       }
  //     } else {
  //       console.warn("No invoices found");
  //     }
  //   } catch (error) {
  //     console.error("Failed to fetch invoices", error);
  //   }
  // };

  const FetchData = async () => {
    // Destructure selectedInvoice for clarity
    const invoiceId = selectedInvoice?.selectedInvoice?.id;

    // Early exit if no valid invoice ID is found
    if (!invoiceId) {
      console.error("No valid invoice ID found in selectedInvoice");
      return;
    }

    try {
      // Fetch invoice data by ID
      const result = await GetInvoiceService(invoiceId);

      if (result) {
        setInvoiceDataSource([result]); //result

        UpdateSelectedInvoiceData(result);
      } else {
        console.warn(`No data found for invoice ID: ${invoiceId}`);
      }
    } catch (error) {
      // Log error details and provide context
      console.error(`Failed to fetch invoice data for ID: ${invoiceId}`, error);
    }
  };

  const UpdateSelectedInvoiceData = (result: any) => {
    // Update the selected invoice data in Redux store
    dispatch(setSelectedInvoiceData(result));
  };
  const handleDelete = async () => {
    const invoiceId = selectedInvoice.selectedInvoice.id;
    if (!invoiceId) return;

    try {
      await DeleteInvoice(invoiceId);
      setOpenPopup(false);
      setInvoiceView(false);
      AlertMessage({ text: "Invoice deleted successfully", type: "success" });
    } catch (error: any) {
      AlertMessage({
        text: error.message || "Failed to delete invoice",
        type: "error",
      });
    } finally {
      refreshInvoices();
    }
  };
  const loadFullInvoice = async (id: any) => {
    if (!id) return;
    setLoaderStatus(true);
    try {
      const fullInvoice = await GetInvoiceService(id);
      if (fullInvoice) {
        setInvoiceDataSource([fullInvoice]);
        dispatch(setSelectedInvoiceData(fullInvoice));

        makeInvoiceViewed(fullInvoice.invoiceId, fullInvoice.stageId);
      }
    } catch (error) {
      console.error("Error loading invoice:", error);
    } finally {
      setLoaderStatus(false);
    }
  };

  const handleRefreshInvoice = async () => {
    const invoiceId = selectedInvoice?.selectedInvoice?.id;
    if (!invoiceId) return;

    try {
      refreshInvoices();
      await loadFullInvoice(invoiceId);
    } catch (error) {
      console.error("Error refreshing invoice:", error);
    }
  };

  const handleNextInvoice = async () => {
    if (currentInvoiceIndex < allInvoices.length - 1) {
      const nextIndex = currentInvoiceIndex + 1;

      setLoaderStatus(true);
      setCurrentInvoiceIndex(nextIndex);

      const nextInvoice = allInvoices[nextIndex];

      try {
        await loadFullInvoice(nextInvoice.id);
        dispatch(setSelectedInvoice(nextInvoice));
      } catch (error) {
        console.error("Error loading invoice:", error);
      } finally {
        setLoaderStatus(false);
      }
    }
  };

  const handlePreviousInvoice = async () => {
    if (currentInvoiceIndex > 0) {
      const prevIndex = currentInvoiceIndex - 1;

      setLoaderStatus(true);
      setCurrentInvoiceIndex(prevIndex);

      const prevInvoice = allInvoices[prevIndex];

      try {
        await loadFullInvoice(prevInvoice.id);
        dispatch(setSelectedInvoice(prevInvoice));
      } catch (error) {
        console.error("Error loading invoice:", error);
      } finally {
        setLoaderStatus(false);
      }
    }
  };

  //Todo Fetch the redux state for current selected invoice and send it to service ot fetch the invoice details
  useEffect(() => {
    const invoices = fullinvoices ?? [];
    setAllInvoices(invoices);

    const currentId = selectedInvoice?.selectedInvoice?.id;
    const index = invoices.findIndex((inv: any) => inv.id === currentId);

    if (index !== -1) {
      setCurrentInvoiceIndex(index);
    } else {
      setCurrentInvoiceIndex(0); // fallback
    }

    loadFullInvoice(currentId);
  }, []);

  // Keyboard navigation for Next (Ctrl + K) and Previous (Ctrl + J)
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Avoid triggering inside input/textarea fields
      const target = event.target as HTMLElement;
      const isTyping =
        target.tagName === "INPUT" ||
        target.tagName === "TEXTAREA" ||
        target.isContentEditable;

      if (isTyping) return;

      // Ctrl + K → Next
      if (event.ctrlKey && event.key.toLowerCase() === "k") {
        event.preventDefault();
        if (currentInvoiceIndex < allInvoices.length - 1) {
          handleNextInvoice();
        }
      }

      // Ctrl + J → Previous
      if (event.ctrlKey && event.key.toLowerCase() === "j") {
        event.preventDefault();
        if (currentInvoiceIndex > 0) {
          handlePreviousInvoice();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [currentInvoiceIndex, allInvoices]);
  const handleclose = () => {
    setInvoiceView(false);
    refreshInvoices();
  };
  // Don't need this second useEffect anymore - FetchAllInvoices handles the full data fetch
  // The data will be loaded when component mounts and when navigating with Next/Previous buttons
  return (
    <div className="invoiceView">
      <div className="invoiceView-header">
        <div style={{ marginRight: "20px" }}>
          <Tooltip title="Delete This Invoice" description="">
            <button
              style={{
                backgroundColor: hover ? "#f0f0f0" : "transparent",
                border: "none",
                padding: "6px",
                borderRadius: "4px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                transform: hover ? "scale(1.2)" : "scale(1)",
              }}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              onClick={() => setOpenPopup(true)}
            >
              <MdDelete
                size={22}
                style={{ color: hover ? "red" : "darkred" }}
              />
            </button>
          </Tooltip>
        </div>
        <div className="invoiceView-header-pagination">
          Invoice View ({currentInvoiceIndex + 1} of {totalInvoiceCount})
        </div>
        <div style={{ display: "flex", gap: "10px", marginRight: "10px" }}>
          <Tooltip title="Previous" description="shortcut: ctrl + j">
            <button
              disabled={currentInvoiceIndex === 0}
              style={{
                backgroundColor:
                  currentInvoiceIndex === 0 ? "#cccccc" : "var(--color-brand)",
                color: "#ffffff",
                padding: "4px 8px",
                borderRadius: "4px",
                border: "none",
                cursor: currentInvoiceIndex === 0 ? "not-allowed" : "pointer",
              }}
              onClick={handlePreviousInvoice}
            >
              Previous
            </button>
          </Tooltip>
          <Tooltip title="Next" description="shortcut: ctrl + k">
            <button
              disabled={currentInvoiceIndex === allInvoices.length - 1}
              style={{
                backgroundColor:
                  currentInvoiceIndex === allInvoices.length - 1
                    ? "#cccccc"
                    : "var(--color-brand)",
                color: "#ffffff",
                padding: "4px 8px",
                borderRadius: "4px",
                border: "none",
                width: "70px",
                cursor:
                  currentInvoiceIndex === allInvoices.length - 1
                    ? "not-allowed"
                    : "pointer",
              }}
              onClick={handleNextInvoice}
            >
              Next
            </button>
          </Tooltip>
        </div>
        {/* <div style={{ marginRight: "20px" }}>
          {" "}
          <button
            style={{
              backgroundColor: "#db0720ff",
              color: "#ffffff",
              padding: "4px",
              borderRadius: "2px",
              border: "none",
            }}
            onClick={() => setOpenPopup(true)}
          >
            Delete Invoice
          </button>
        </div> */}
        <div className="invoiceView-header-close" onClick={() => handleclose()}>
          <Tooltip title="Close Invoice View" description="">
            <CancelBtn style={{ color: hover ? "red" : "darkred" }} />
          </Tooltip>
        </div>
      </div>
      <div className="invoiceView-body">
        {loaderStatus ? (
          <div className="invoiceView-loader">
            <Loader />
          </div>
        ) : (
          <>
            <div className="invoiceView-body-left">
              <InvoiceDocumentViewer />
            </div>
            <div className="invoiceView-body-right">
              {loaderStatus ? (
                <Loader />
              ) : (
                <InvoiceForm
                  setInvoiceView={setInvoiceView}
                  invoiceDataSource={invoiceDataSource}
                  //setLoaderStatus={setLoaderStatus}
                  handleNextInvoice={handleNextInvoice}
                  isLastInvoice={currentInvoiceIndex === allInvoices.length - 1}
                  refreshInvoices={handleRefreshInvoice}
                />
              )}
            </div>
          </>
        )}
        <ConfirmPopup
          isOpen={openPopup}
          title="Delete Invoice"
          message="Do you want to delete this invoice?"
          onConfirm={handleDelete}
          onCancel={() => setOpenPopup(false)}
        />
      </div>
    </div>
  );
};
export default ArchiveInvoiceView;
function makeInvoiceViewed(invoiceId: number, stageId: number) {
  throw new Error("Function not implemented.");
}